import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { delay, startWith } from 'rxjs';
import { SiteModel } from 'src/app/models/index';
import { UserManagementService } from 'src/app/services/index';
import { AlertService, Constants } from 'src/app/shared';
import { AddUserSuccessModalComponent } from './add-user-success-modal/add-user-success-modal.component';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit, AfterViewInit {
  formData: UntypedFormGroup;
  sites: any;
  roles: any;
  selected: SiteModel;
  user = {
    role: Constants.USER_ROLE.USER,
    emailRecipientClass: 'To',
    email: '',
    site: new SiteModel(),
    ntID: ''
  };
  error = {
    role: ''
  };
  maxSiteUserPerSite = 0;
  emailRecipientClass = ['To', 'Cc', 'Bcc', 'None'];
  firstNamePattern = '^([^0-9]*)$';
  typed = false;
  constructor(
    private alertService: AlertService,
    private userManagementService: UserManagementService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      projectCtr: ['', [Validators.required]],
      // firstNameCtr: ['', [Validators.required]],
      // middleNameCtr: [''],
      // lastNameCtr: [''],
      emailCtr: ['', [Validators.required, Validators.email]],
      roleCtr: [''],
      ntIDCtr: ['']
    });
  }

  ngAfterViewInit() {
    this.reset();
    this.loadData();
  }

  loadData() {
    const t = this;

    t.userManagementService
      .getSitesWithUsers()
      .pipe(startWith(null), delay(0))
      .subscribe((data) => {
        if (data && data.data.length > 0) {
          t.sites = data.data;
        }
      });
    t.userManagementService
      .getMaxSiteUserPerSite()
      .pipe(startWith(null), delay(0))
      .subscribe((data) => {
        if (data) {
          t.maxSiteUserPerSite = data.data;
        }
      });
    t.userManagementService
      .getRoles()
      .pipe(startWith(null), delay(0))
      .subscribe((data) => {
        if (data && data.data.length > 0) {
          t.roles = data.data;
        }
      });
  }

  reset() {
    this.user = {
      role: Constants.USER_ROLE.USER,
      emailRecipientClass: 'To',
      email: '',
      site: new SiteModel(),
      ntID: ''
    };
  }

  save() {
    const t = this;
    if (this.formData.valid && this.validateForm()) {
      t.userManagementService.saveOrUpdateUser(t.user).subscribe((data) => {
        if (data.code !== 200) {
          t.alertService.showError(data.message);
        } else {
          t.user = data.data;
          if (t.user.site !== undefined) {
            for (let i = 0; i < t.sites.length; i++) {
              if (t.sites[i].siteId === t.user.site.siteId) {
                t.sites[i].siteUsers.push(t.user);
                break;
              }
            }
          }
          this.openModal();
        }
      });
    }
  }

  openModal() {
    const t = this;
    const dialogRef = this.dialog.open(AddUserSuccessModalComponent, {
      width: '800px'
    });
    dialogRef.componentInstance.user = t.user;

    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        console.log(result.status);
      }
    });
  }

  validateForm() {
    let result = true;

    if (
      this.user.site !== undefined &&
      this.user.site.siteUsers.length >= this.maxSiteUserPerSite
    ) {
      this.error.role =
        'This site has exceeded ' +
        this.maxSiteUserPerSite +
        'users, cannot add more.';
      result = false;
    }
    return result;
  }

  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  };

  emailRecipientClassChange(type) {
    this.user.emailRecipientClass = type;
  }

  siteChange(event) {
    const siteId = event.value;
    this.user.site = this.sites.find((c) => c.siteId === siteId);
  }
}
